//import React from 'react';
const PAGE = [
  {
    "content": `User Name`
  },
  {
    "content": `Treatment Plan ID`
  },
  {
    "content": `Created`
  },
  {
    "content": `Step`
  },
  {
    "content": "View"
  },
  {
    "content": "Action"
  },
  {
    "content": "No Items Found"
  },
  {
    "content": "Edit"
  },
  {
    "content": "Creating"
  },
  {
    "content": "Approve"
  }
];




  
export default PAGE;